import { defineMessages } from 'react-intl';

export default defineMessages({
  error: 'Error',
  submit: 'Submit',
  goBack: 'Go back',

  copyError: 'Copy error',
  copied: 'Copied',
  showError: 'Show error',

  errorReport: 'Error report generated',
  copyErrorAndClose: 'Copy error & close',
});
